export class AuthService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async login(name, email) {
        const response = await this.apiService.post('auth-client', { name, email });
        if (!response.ok) {
            throw new Error('Ha ocurrio un error al efectuar el login.');
        }
        const content = await response.json();
        return content.accessToken;
    }
    async getToken(accessToken) {
        const response = await this.apiService.post('auth-client-access/', { accessToken });
        if (!response.ok) {
            throw new Error('Ha ocurrio un error al efectuar el login.');
        }
        const content = await response.json();
        return content.accessToken;
    }
    async sendEmailToken(email) {
        const response = await this.apiService.post('auth-client-email', { email });
        if (!response.ok) {
            throw new Error('Ha ocurrio un error al efectuar el email.');
        }
        return true;
    }
}
